/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListSpendRuleEventsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSpendRuleEventsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSpendRuleEventsSecurity = {
  option1?: ListSpendRuleEventsSecurityOption1 | undefined;
  option2?: ListSpendRuleEventsSecurityOption2 | undefined;
};

/**
 * Optional event type to filter by.
 */
export const EventType = {
  Warning: "warning",
  Breach: "breach",
} as const;
/**
 * Optional event type to filter by.
 */
export type EventType = ClosedEnum<typeof EventType>;

export type ListSpendRuleEventsRequest = {
  /**
   * Optional rule ID to filter by. Matches the rule's whole lineage: events from every version of the rule are returned.
   */
  ruleId?: string | undefined;
  /**
   * Optional event type to filter by.
   */
  eventType?: EventType | undefined;
  /**
   * Cursor to fetch the next page of events.
   */
  cursor?: string | undefined;
  /**
   * Maximum number of events to return per page.
   */
  limit?: number | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListSpendRuleEventsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSpendRuleEventsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListSpendRuleEventsSecurityOption1$Outbound,
  ListSpendRuleEventsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listSpendRuleEventsSecurityOption1ToJSON(
  listSpendRuleEventsSecurityOption1: ListSpendRuleEventsSecurityOption1,
): string {
  return JSON.stringify(
    ListSpendRuleEventsSecurityOption1$outboundSchema.parse(
      listSpendRuleEventsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSpendRuleEventsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSpendRuleEventsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListSpendRuleEventsSecurityOption2$Outbound,
  ListSpendRuleEventsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSpendRuleEventsSecurityOption2ToJSON(
  listSpendRuleEventsSecurityOption2: ListSpendRuleEventsSecurityOption2,
): string {
  return JSON.stringify(
    ListSpendRuleEventsSecurityOption2$outboundSchema.parse(
      listSpendRuleEventsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSpendRuleEventsSecurity$Outbound = {
  Option1?: ListSpendRuleEventsSecurityOption1$Outbound | undefined;
  Option2?: ListSpendRuleEventsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSpendRuleEventsSecurity$outboundSchema: z.ZodMiniType<
  ListSpendRuleEventsSecurity$Outbound,
  ListSpendRuleEventsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSpendRuleEventsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSpendRuleEventsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSpendRuleEventsSecurityToJSON(
  listSpendRuleEventsSecurity: ListSpendRuleEventsSecurity,
): string {
  return JSON.stringify(
    ListSpendRuleEventsSecurity$outboundSchema.parse(
      listSpendRuleEventsSecurity,
    ),
  );
}

/** @internal */
export const EventType$outboundSchema: z.ZodMiniEnum<typeof EventType> = z.enum(
  EventType,
);

/** @internal */
export type ListSpendRuleEventsRequest$Outbound = {
  rule_id?: string | undefined;
  event_type?: string | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSpendRuleEventsRequest$outboundSchema: z.ZodMiniType<
  ListSpendRuleEventsRequest$Outbound,
  ListSpendRuleEventsRequest
> = z.pipe(
  z.object({
    ruleId: z.optional(z.string()),
    eventType: z.optional(EventType$outboundSchema),
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      ruleId: "rule_id",
      eventType: "event_type",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSpendRuleEventsRequestToJSON(
  listSpendRuleEventsRequest: ListSpendRuleEventsRequest,
): string {
  return JSON.stringify(
    ListSpendRuleEventsRequest$outboundSchema.parse(listSpendRuleEventsRequest),
  );
}
